module.exports = __webpack_public_path__ + "img/购买热线.3b19cf12.png";